import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function getActivityCVByUserId({ userId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetActivityCVByUserId',
    params: { UserId: userId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getCurrentUserActivityCV() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetActivityCurrentUserCV',
  });
  return data;
}

async function getCurrentUserContactInfo() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetCurrentUserContactInfo',
  });
  if(data !== null) {
    for( let i = 0; i < data.userSocialNetworks?.length; i++ ) {
      console.log(data.userSocialNetworks[i]);
      data.userSocialNetworks[i].iconURL = await getSocialNetworkIconURL({name: data.userSocialNetworks[i].name});
    }
  }
  return data;
}

async function getUserContactInfoByUserId({ userId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetUserContactInfoByUserId',
    params: { UserId: userId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getSocialsTypeDescriptions(entity) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/SocialNetwork/GetSocialNetworkTypeDescriptions',
    params: { Entity: entity },
  });
  return data;
}

async function updateUserContactInfo({ dataObject }) {
  // const formData = new FormData();
  // Object.keys(sanitizePostData(dataObject)).forEach((key) => {
  //   if (dataObject[key] !== null) {
  //     formData.append(key, dataObject[key]);
  //   }
  // });

  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/UpdateUserContactInfo',
    // data: formData,
    data: sanitizePostData(dataObject),
    generalErrorsOnly: true,
  });
  return data;
}

async function addUserSocial({ accountLink, socialNetworkId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/AddUserSocialNetwork',
    data: sanitizePostData({
      accountLink,
      socialNetworkId,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function updateUserSocial({ accountLink, userSocialNetworkId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/UpdateUserSocialNetwork',
    data: sanitizePostData({
      accountLink,
      userSocialNetworkId,
    }),
    generalErrorsOnly: true,
  });
  return data;
}

async function removeUserSocial({ userSocialNetworkId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RemoveUserSocialNetwork',
    data: sanitizePostData({ userSocialNetworkId }),
  });
  return data;
}

async function getLatestUserEvents({ userId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetLatestUserEvents',
    params: { UserId: userId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getCurrentUserLatestEvents() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetCurrentUserLatestEvents',
  });
  return data;
}

async function getCurrentUserAllEvents() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetCurrentUserAllEvents',
  });
  return data;
}

async function getUserAllEvents({ userId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetAllUserEvents',
    params: { UserId: userId },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function sendMessageToUser({ userId, text }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/SendMessageToUser',
    data: sanitizePostData({ userId, message: { text } }),
    generalErrorsOnly: true,
  });
  return data;
}

async function sendConnectionRequestToUser({ userId, text }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RequestConnection',
    data: sanitizePostData({ userId, message: { text} }),
    generalErrorsOnly: true,
  });
  return data;
}

async function respondToConnectRequest({ userId, accept }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RespondToConnectionRequest',
    data: sanitizePostData({ userId, accept }),
    generalErrorsOnly: true,
  });
  return data;
}

async function revokeConnection({ userId}) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RevokeConnection',
    data: sanitizePostData({ userId }),
    generalErrorsOnly: true,
  });
  return data;
}

async function getConnections(type, skip, limit) {
  //console.log("Skip: " + skip + " Take: " + limit);

  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetConnections',
    params: { type, skip, limit },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getUserIdByLink({ link }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetUserIdByLink',
    params: { link },
    isAuthCheckSkipped: true,
  });
  return data;
}

async function getAvatar(_userId) {
  // Define a unique cache key for the avatar
  //const cacheKey = `avatar_${_userId}`;

  // Check if the avatar is already cached
  // const cachedAvatar = localStorage.getItem(cacheKey);

  // if (cachedAvatar) {
  //   // If cached, convert the Base64 string back to a Blob and return it
  //   const blob = base64ToBlob(cachedAvatar);

  //   if( blob !== undefined && blob !== null ) {
  //     return blob;
  //   }
  // }

  // If not cached, fetch the avatar from the API
  const { data, headers } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetAvatarPicture',
    params: { UserId: _userId },
    responseType: 'arraybuffer',
  });

  // Extract content type from headers
  const contentType = headers['content-type'];

  // Create a Blob from the received data
  const blob = new Blob([data], { type: contentType });

  // // Convert the Blob to a Base64-encoded string for caching
  // const base64Data = await blobToBase64(blob);

  // try
  // {
  //   // Cache the Base64-encoded avatar in localStorage
  //   localStorage.setItem(cacheKey, base64Data);
  // }
  // catch(e)
  // {
  //   console.log(e);
  // }

  // Return the Blob
  return blob;
}

// Helper function to convert a Blob to a Base64-encoded string
function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // Extract the Base64 data from the result
      const base64data = reader.result.split(',')[1];
      resolve(base64data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Helper function to convert a Base64-encoded string back to a Blob
function base64ToBlob(base64Data) {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'image/jpeg' }); // Adjust the MIME type if necessary
}

async function getProfileImage(_userId ) {

  const { data, headers } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetProfilePicture',
    params: { UserId: _userId },
    responseType: 'arraybuffer'
  });

  // Extract content type from headers
  const contentType = headers['content-type'];

  // Create a Blob from the received data
  const blob = new Blob([data], { type: contentType });

  // Return the Blob or a URL for it (depending on usage)
  return blob;
}

async function getOnboardingStatus() {
  // Adjust the URL if your endpoint differs
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetOnboardingStatus',
    generalErrorsOnly: true,
  });
  return data; // e.g. { onboardingStatus: "Completed" } or null
}

export {
  getActivityCVByUserId,
  getCurrentUserContactInfo,
  getUserContactInfoByUserId,
  getCurrentUserActivityCV,
  getSocialsTypeDescriptions,
  updateUserContactInfo,
  addUserSocial,
  updateUserSocial,
  removeUserSocial,
  getLatestUserEvents,
  getCurrentUserLatestEvents,
  getCurrentUserAllEvents,
  getUserAllEvents,
  sendMessageToUser,
  sendConnectionRequestToUser,
  getUserIdByLink,
  getAvatar,
  getProfileImage,
  respondToConnectRequest,
  revokeConnection,
  getConnections,
  getOnboardingStatus
};
